/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Input as ThemeUiInput } from 'theme-ui';
import * as Icons from '@tishman/icons';
import React from 'react';

import { Flex, getMargin, Button, omitMargin, ButtonProps } from '.';

import type { ComponentProps } from 'react';

export function ListFilterSearch({
  onChange,
  onClick,
  onKeyDown,
  defaultValue,
  pageName = '',
  ...props
}: Omit<ButtonProps, 'onChange'> &
  ComponentProps<typeof ThemeUiInput> & {
    pageName?: string;
  }): React.JSX.Element {
  return (
    <Flex
      {...getMargin(props)}
      sx={{
        'position': 'relative',
        'justifyContent': ['flex-start', null, 'center'],
        '@media screen and (max-width: 500px)': {
          marginLeft: '8px',
          marginRight: '8px',
        },
      }}
    >
      <Button
        aria-label="search"
        onClick={(event) => onClick?.(event)}
        role="img"
        sx={{
          color: 'text',
          position: 'absolute',
          margin: 'auto',
          alignSelf: 'center',
          top: 0,
          bottom: 0,
          left: [0, 0],
          p: 1,
          lineHeight: 1,
        }}
        variant="icon"
      >
        <Icons.Search aria-hidden />
      </Button>
      <ThemeUiInput
        defaultValue={defaultValue}
        name="q"
        placeholder={pageName ? `Search in ${pageName}` : 'Search by Name'}
        {...omitMargin(props)}
        onChange={(event) => {
          onChange?.(event);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            onKeyDown?.(event);
          }
        }}
        sx={{
          'fontFamily': 'body',
          'fontWeight': 'normal',
          'fontSize': [3, null, 3, 3],
          'border': 'none',
          'outline': 'none',
          'lineHeight': 'inherit',
          'mb': [0, 0],
          'textOverflow': 'ellipsis',
          'borderBottom': '1px solid currentColor',
          'py': 3,
          'paddingLeft': '35px',
          // a11y: fixing the placeholder value when zoom is set to 150% or more
          '@media screen and (min-resolution: 144dpi) and (max-width: 900px)': {
            fontSize: '1rem',
          },
        }}
      />
    </Flex>
  );
}
